import axiosInstance from "api/axiosConfig"
import { ENDPOINTS } from "api/endpoints"
import { User } from "types/user"

const handleApiError = (message: string, err: unknown): never => {
  console.error(message, err)
  throw new Error(message)
}

const useUserService = () => {
  const loadUser = async (): Promise<any> => {
    try {
      const response = await axiosInstance.get(
        ENDPOINTS.USERS.LOAD_USER
      )

      if (!response.data) {
        throw new Error()
      }

      return response.data
    } catch (err) {
      handleApiError(`Failed to fetch user`, err)
    }
  }

  const loadUsers = async (): Promise<any> => {
    try {
      const response = await axiosInstance.get<User[]>(
        ENDPOINTS.USERS.LOAD_USERS
      )

      if (!response.data) {
        throw new Error()
      }

      return response.data
    } catch (err) {
      handleApiError('Failed to fetch users', err)
    }
  }

  const updateUser = async (userData: any): Promise<any> => {
    try {
      const response = await axiosInstance.post<User>(
        `${ENDPOINTS.USERS.UPDATE_PROFILE}`,
        userData
      )

      if (!response.data) {
        throw new Error('Failed to update user data')
      }

      return response.data
    } catch (err) {
      handleApiError(`Failed to update user with ID: ${userData.id}`, err)
    }
  }

  return {
    loadUser,
    loadUsers,
    updateUser,
  }
}

export default useUserService
